<template>
    <div class="grccomp-error-bubble" v-html="ErrorText" v-show="IsVisible"></div>
</template>

<script>


export default {
  name: 'GrcCompErrorBubble',
  components: {
  },
  props: {
  },
  data () {
      return {
          IsVisible: false,
          ErrorText: ""
      }
  },
  model: {
  },  
  methods:{
      ShowError(pText)
      {
          this.ErrorText = pText;
          this.IsVisible = true;
      },

      HideError()
      {
          this.IsVisible = false;
      }

  },
  created()
  {

  },
  mounted()
  {

  }

}


</script>

